export default __webpack_public_path__ + "static/media/trash.252f3f75.svg";